module.exports = __webpack_public_path__ + "img/landing-footer-domlabs.a0587ace.svg";